import {NavLink, useLocation} from 'react-router-dom';
import styles from './navigation.module.scss';
import {useAppSelector} from '../../store/store';
import {isAuthenticatedSelector} from '../../store/slices/exchange_token_slice';
import {unreadMessagesCountSelector} from '../../store/slices/chat_slice';
import {unreadNotificationsCountSelector} from '../../store/slices/notifications_slice';
import {NavigationDropup} from './navigation_dropup.tsx';
import {__, transString} from '../../support/lang/translations';
import {navLinkClass} from './navigation.tsx';
import menuStyles from './navigation.module.scss';
import {MenuItemType} from '../../gql/pwa/graphql.ts';

export function DesktopNavigation() {
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);

    const extraMenuItems = (appConfig?.menu_extra && (appConfig.menu_extra as MenuItemType[])) || [];

    const isAuthenticated = useAppSelector(isAuthenticatedSelector);
    const unreadMessagesCount = useAppSelector(unreadMessagesCountSelector);
    const unreadNotificationsCount = useAppSelector(unreadNotificationsCountSelector);

    const location = useLocation();
    const {pathname} = location;
    const isProfileOpen = pathname.includes('profile') || pathname.includes('vehicles');

    const organisation = useAppSelector((state) => state.appConfig.organisation);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const locations = useAppSelector((state) => state.appConfig.locations);

    const defaultLocationId = meData?.default_location_id;
    const defaultLocation = locations
        ? defaultLocationId
            ? locations?.filter((l) => l?.id === defaultLocationId)[0]
            : locations.length > 0
              ? locations[0]
              : null
        : null;

    let whatsAppNumber = organisation?.whatsapp_number;
    if (defaultLocation != null && defaultLocation.whatsapp_number != null) {
        whatsAppNumber = defaultLocation.whatsapp_number;
    }

    return (
        <nav className={styles.nav}>
            {!isAuthenticated && (
                <div className={styles.nav__menu}>
                    <NavLink to="/login" className={navLinkClass} title={transString('nav.home')} viewTransition={true}>
                        <span className={styles.item__icon}>
                            <i className="fa-light fa-grip"></i>
                        </span>
                        <span className={styles.item__text}>{__('nav.home')}</span>
                    </NavLink>
                </div>
            )}
            {isAuthenticated && (
                <div className={styles.nav__menu}>
                    <NavLink to="/" className={navLinkClass} title={transString('nav.home')} viewTransition={true}>
                        <span className={styles.item__icon}>
                            <i className="fa-light fa-grip"></i>
                        </span>
                        <span className={styles.item__text}>{__('nav.home')}</span>
                    </NavLink>

                    {!whatsAppNumber && (
                        <NavLink
                            to="chat"
                            className={navLinkClass}
                            title={transString('nav.support')}
                            viewTransition={true}
                        >
                            <span className={styles.item__icon}>
                                <i className="fa-regular fa-comments"></i>
                            </span>
                            <span className={styles.item__text}>{__('nav.support')}</span>
                            {unreadMessagesCount !== 0 ? (
                                <div className={styles.item__count}>{unreadMessagesCount}</div>
                            ) : null}
                        </NavLink>
                    )}
                    <NavLink
                        to="notifications"
                        className={navLinkClass}
                        title={transString('nav.inbox')}
                        viewTransition={true}
                    >
                        <span className={styles.item__icon}>
                            <i className="fa-light fa-inbox"></i>
                        </span>
                        <span className={styles.item__text}>{__('nav.inbox')}</span>
                        {unreadNotificationsCount !== 0 ? (
                            <div className={styles.item__count}>{unreadNotificationsCount}</div>
                        ) : null}
                    </NavLink>
                </div>
            )}

            <div className={styles.nav__menu}>
                <div className={styles.menu__header}>
                    <span>{__('nav.service_support')}</span>
                </div>
                {isAuthenticated && (
                    <NavLink
                        to="appointment"
                        className={navLinkClass}
                        title={transString('nav.appointment')}
                        viewTransition={true}
                    >
                        <span className={styles.item__icon}>
                            <i className="fa-regular fa-calendar-days"></i>
                        </span>
                        <span className={styles.item__text}>{__('nav.appointment')}</span>
                    </NavLink>
                )}
                <NavLink to="damage" className={navLinkClass} title={transString('nav.damage')} viewTransition={true}>
                    <span className={styles.item__icon}>
                        <i className="fa-light fa-exclamation-triangle"></i>
                    </span>
                    <span className={styles.item__text}>{__('nav.damage')}</span>
                </NavLink>
                {isAuthenticated && (
                    <NavLink
                        to="faults"
                        className={navLinkClass}
                        title={transString('nav.faults')}
                        viewTransition={true}
                    >
                        <span className={styles.item__icon}>
                            <i className="fa-regular fa-lightbulb"></i>
                        </span>
                        <span className={styles.item__text}>{__('nav.faults')}</span>
                    </NavLink>
                )}
                <NavLink to="contact" className={navLinkClass} title={transString('nav.contact')} viewTransition={true}>
                    <span className={styles.item__icon}>
                        <i className="fa-light fa-phone"></i>
                    </span>
                    <span className={styles.item__text}>{__('nav.contact')}</span>
                </NavLink>

                <div className={styles.menu__header}>
                    <span>{appConfig?.appname ?? ''}</span>
                </div>
                <NavLink
                    to="occasions"
                    className={navLinkClass}
                    title={transString('nav.occasions')}
                    viewTransition={true}
                >
                    <span className={styles.item__icon}>
                        <i className="fa-light fa-car-alt"></i>
                    </span>
                    <span className={styles.item__text}>{__('nav.occasions')}</span>
                </NavLink>
                <NavLink to="news" className={navLinkClass} title={transString('nav.news')} viewTransition={true}>
                    <span className={styles.item__icon}>
                        <i className="fa-regular fa-newspaper"></i>
                    </span>
                    <span className={styles.item__text}>{__('nav.news')}</span>
                </NavLink>
                <NavLink to="reviews" className={navLinkClass} title={transString('nav.reviews')} viewTransition={true}>
                    <span className={styles.item__icon}>
                        <i className="fa-regular fa-star"></i>
                    </span>
                    <span className={styles.item__text}>{__('nav.reviews')}</span>
                </NavLink>

                {extraMenuItems != null && extraMenuItems.length > 0 && (
                    <div className={styles.menu__header}>
                        <span>{__('nav.information')}</span>
                    </div>
                )}
                {extraMenuItems.map((extraMenuItem, i) => (
                    <NavLink key={'extra-menu-item-' + i} to={extraMenuItem.url || ''} className={navLinkClass}>
                        <span className={menuStyles.item__icon}>
                            <i className="fa-light fa-link"></i>
                        </span>
                        <span className={menuStyles.item__text}>{extraMenuItem.name}</span>
                    </NavLink>
                ))}
                {isAuthenticated && (
                    <div className={`${styles.nav__profile} ${isProfileOpen ? styles.active : ''}`}>
                        <div className={styles.profile__background}></div>
                        <div className={styles.profile__user}>
                            <NavigationDropup isActive={isProfileOpen} />
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
}
